import Heplers from './../helpers/helpers.js';

export default new class InfinityScroll {
    constructor() {
        this.infinityScrollInit ='.infinity-scroll-init';
        this.infinityScrollInitWrapp ='.infinity-scroll-init-wrapp';

        if (!$(this.infinityScrollInit).length) { return; }

        this.dataSearchType = 'data-search-type';
        this.dataPage = 'data-page';
        this.searchInput = '.js-search-input';
        this.$preloader = $('.js-preloader');
        this.$searchModal = $('.js-search-modal');

        this.bindEvents();
    }

    bindEvents () {
        $(this.infinityScrollInit).scroll((e)=> {
            let searchType = $(e.currentTarget).attr(this.dataSearchType),
                $currentSearch = this.getCurrentSearch(searchType);

            //if user has scrolled to the bottom of search block
            if ($currentSearch[0].scrollTop + $currentSearch[0].clientHeight >= $currentSearch[0].scrollHeight) {
                let searchType = $currentSearch.attr(this.dataSearchType),
                    value = $currentSearch.closest(this.infinityScrollInitWrapp).find(this.searchInput).val(),
                    currentPage = parseInt($currentSearch.attr(this.dataPage)),
                    maxPage = parseInt($currentSearch.find('[data-max-page]').attr('data-max-page'));

                //if its the last page or there is no max-page
                if (maxPage === currentPage || !Number.isInteger(maxPage)) { return; }

                let nextPage = this.setNextPage($currentSearch);

                this.setSearchType({
                    page: nextPage,
                    type: searchType,
                    searchValue: value
                });
            }
        });
    }

    /**
     *
     * @param searchType - string, value of data attr 'data-search-type' on search container
     * @returns {*|jQuery|HTMLElement} - search container
     */
    getCurrentSearch (searchType) {
        let currentSearch = null;

        if (searchType === 'global-search') {
            let deviceType = '';

            if (Heplers.isMobile()) {
                deviceType ='mobile';
            } else {
                deviceType ='desktop';
            }
            currentSearch = $(`${this.infinityScrollInitWrapp}[data-device="${deviceType}"]`).find(`${this.infinityScrollInit}[${this.dataSearchType}="${searchType}"]`);
        } else {
            currentSearch = $(`${this.infinityScrollInit}[${this.dataSearchType}="${searchType}"]`);
        }

        return currentSearch;
    }

    unbindEvents () {
        $(this.infinityScrollInit).unbind( 'scroll' );
    }

    /**
     *
     * @returns {*} string - next page to upload content
     */
    setNextPage ($search) {
        let page = parseInt($search.attr(this.dataPage));

        !page && page === 1 ? page = 2 : page += 1;
        $search.attr(this.dataPage, page);

        return page;
    }

    setDefaultPage (searchType) {
        let defaultPage = 1,
            $search = this.getCurrentSearch(searchType);

        $search.attr(this.dataPage, defaultPage);
    }

    /**
     * Detect search
     *
     * @param params - obj,
     *  params.type - string, type of search
     *  params.page - num, next page to upload
     */
    setSearchType (params) {
        this.unbindEvents();

        let searchRequestUtl = 'ShopaholicSearch::onAjaxSearch';

        switch(params.type) {
            // global search
            case 'global-search':
                this.$preloader.show();

                $.request(searchRequestUtl, {
                    data: { 'search': params.searchValue, 'page': params.page },
                    update: {'jade-search-result.htm': '.search-area__inner' },
                    success: (data) => { $('.search-area__inner').append(data['jade-search-result.htm']); },
                    complete: () => {
                        this.$preloader.hide();
                        this.bindEvents();
                    }
                });
                break;

            //search for add commodity offer
            case 'personal-area-search':
                $.request(searchRequestUtl, {
                    data: { search: params.searchValue, page: params.page, flags: ['user_filter'] },
                    update: { 'product-search-result' : '.add-offer__commodity-list' },
                    loading: '.js-preloaderOverlay',
                    success: (data) => { $('.add-offer__commodity-list').append(data['product-search-result']); },
                    complete: () => {
                        this.bindEvents();
                    }
                });
                break;

            default: console.info('O_o default search request!');
                break;
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/infinity-scroll/infinity-scroll.js